// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ACrH","inner":"Footer_inner__2yb5o"};